import { createFileRoute } from "@tanstack/react-router";
import { getCustomerReport } from "@/lib/admin/analytics/reports.functions";
import { BarList, Card, DailyBars, DataTable, Kpi, KpiGrid, ReportPage, fmt, inr, istTime, useReport } from "@/components/admin/analytics/ReportKit";

export const Route = createFileRoute("/admin/analytics_/customers")({
  head: () => ({ meta: [{ title: "Customer Analytics — CB16 Admin" }, { name: "robots", content: "noindex" }] }),
  component: CustomerAnalyticsPage,
});

function CustomerAnalyticsPage() {
  const report = useReport("customers", getCustomerReport);
  return (
    <ReportPage eyebrow="Analytics" title="Customer Analytics" description="Customers with completed, paid Live orders." report={report}>
      {(d, r) => {
        const file = `customers-${r.range.days[0]}_${r.range.days[r.range.days.length - 1]}`;
        const k = d.kpis;
        const segTotal = d.segments.reduce((s, x) => s + x.customers, 0);
        return (
          <>
            <KpiGrid>
              <Kpi label="Active customers" value={fmt(k.activeCustomers)} sub="Ordered in this period" />
              <Kpi label="New customers" value={fmt(k.newCustomers)} sub="First order in this period" />
              <Kpi label="Returning customers" value={fmt(k.returningCustomers)} />
              <Kpi label="Retention" value={`${k.retentionPct}%`} sub="Returning ÷ active" />
              <Kpi label="Average spend" value={inr(k.averageSpend)} sub="Per active customer" />
              <Kpi label="All-time customers" value={fmt(k.totalCustomers)} />
              <Kpi label="Repeat customers" value={fmt(k.repeatCustomers)} sub={`${k.repeatRatePct}% ordered 2+ times`} />
              <Kpi label="Lifetime value" value={inr(k.lifetimeValue)} sub="Average per customer" />
            </KpiGrid>
            <section className="grid gap-4 lg:grid-cols-3">
              <Card title="New customers per day" rows={d.newTrend} file={`${file}-new`} className="lg:col-span-2"><DailyBars points={d.newTrend} /></Card>
              <Card title="Segments (all time)" rows={d.segments} file={`${file}-segments`}>
                <BarList rows={d.segments.map((s) => ({ label: s.segment, value: s.customers, sharePct: segTotal ? Math.round((s.customers / segTotal) * 1000) / 10 : 0 }))} />
              </Card>
            </section>
            <Card title="Customers" rows={d.customers} file={`${file}-list`}>
              <DataTable
                head={["Customer", "Segment", "Orders (period)", "Spend (period)", "Lifetime orders", "Lifetime spend", "Last order (IST)"]}
                rows={d.customers.map((c) => [c.email, c.segment, fmt(c.ordersInRange), inr(c.spendInRange), fmt(c.lifetimeOrders), inr(c.lifetimeSpend), istTime(c.lastOrder)])}
              />
            </Card>
            <p className="text-[11px] text-black/40">Test, demo, failed, unpaid and cancelled orders are left out, so test-only accounts do not appear.</p>
          </>
        );
      }}
    </ReportPage>
  );
}
